import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Criteria } from '../compRateCard.model';
import { NgForm } from '@angular/forms';
import { CommonService } from 'app/shared/services/common.service';
import { RateCardService } from '../compRateCard.service';
import { COMMON_UMS } from 'app/config/userMessages_en';
import { ExpressionCriteria } from '../../planCompSetup/planCompSetup.model';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-criteria-rate-modal',
  templateUrl: './criteria-rate-modal.component.html',
  styleUrls: ['./criteria-rate-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [RateCardService]
})

export class CriteriaRateModalComponent {
  @ViewChild('crForm') crForm!: NgForm;
  @Input() data: any;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  public criteriaTypesArray: Array<any> = [];
  public criteriaArray: Array<any> = [];
  public operatorsArray: Array<any> = [];
  public criteriaRates: Array<ExpressionCriteria> = [];
  public noCriteriaRules = false;
  public isValid = true;
  public duplicateCR: any;
  public crOperationIndex = 0
  public criteriaRateErrorObj = {
    state: 'error',
    userMessage: ''
  };
  public mlsSettings: IDropdownSettings = {
    allowSearchFilter: false,
    itemsShowLimit: 1,
    enableCheckAll: true,
    selectAllText: 'Select All',
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    unSelectAllText: 'UnSelect All',
  };

  constructor(
    public dialog: BsModalRef,
    private commonService: CommonService,
    private rateCardService: RateCardService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    const contextData = this.data;

    this.criteriaRates = contextData.criteriaRates;
    this.criteriaArray = contextData.criteriaArray;
    this.criteriaTypesArray = contextData.criteriaTypesArray;
    this.operatorsArray = contextData.operators;

    // Convert numeric IDs to objects for dropdown display
    this.criteriaRates.forEach(cr => {
      if (cr.criteriaType === 'Titles' && Array.isArray(cr.existingTitles)) {
        if (typeof cr.existingTitles[0] === 'number') {
          cr.existingTitles = this.data.titlesForCriteria
            .filter((t: any) => cr.existingTitles.includes(+t.id))
            .map((t: any) => ({ id: t.id, name: t.name }));
        }
      }
    });

    this.criteriaRates.forEach(type => {
      if (type.criteriaType === 'Volumes') {
        type['criteriaArray'] = contextData.globalVolDefinitions;
        type['operatorsArray'] = contextData.operators;
      } else if (type.criteriaType === 'Key Metrics') {
        type['criteriaArray'] = contextData.metricDefinitionsMetaData
        type['operatorsArray'] = contextData.operators
      } else if(type.criteriaType === 'Titles') {
        type['criteriaArray'] = contextData.titlesForCriteria;
        type['operatorsArray'] = contextData.operators;
      } else if(type.criteriaType === 'Flags') {
        type['criteriaArray'] = contextData.flagsForCriteria;
        type['operatorsArray'] = contextData.operators;
        const flag = type.criteriaArray?.find(item => item.code === type.criteria);
        if (flag && flag.flagValues) {
          type['flagValues'] = flag.flagValues.map((item: any) => {
          return {
            ...item,
            name:item.value
          };
        });
      }
      } else if (type.criteriaType === 'Duration') {
        type['criteriaArray'] = contextData.consecutivePeriodsArray;
        type['operatorsArray'] = contextData.operators
      } else {
        type['criteriaArray'] = [];
        type['operatorsArray'] = contextData.operators;
      }
    });
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.dialog.hide();
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public applyCR() {
    // Build payload for backend validation
    const payload = this.criteriaRates.map((cr: ExpressionCriteria) => {
      const newCr: any = { ...cr };

      delete newCr.operationIndex;
      delete newCr.criteriaArray;
      delete newCr.operatorsArray;
      delete newCr.criteriaDisplay;
      delete newCr.criteriaTypeDisplay;
      delete newCr.flagValues;
      delete newCr.flagDescription;

      if (newCr.criteriaType === 'Volumes') {
        const vd = this.data.globalVolDefinitions.find((c: any) => c.name === newCr.criteria);
        newCr.criteria = vd ? vd.code : newCr.criteria;
      }
      else if (newCr.criteriaType === 'Key Metrics') {
        const vd = this.data.metricDefinitionsMetaData.find((c: any) => c.name === newCr.criteria);
        newCr.criteria = vd ? vd.code : newCr.criteria;
      }
      else if (newCr.criteriaType === 'Titles') {
        // Convert existingTitles to array of numeric IDs
        let selectedIds: number[] = [];

        if (Array.isArray(newCr.existingTitles)) {
          if (typeof newCr.existingTitles[0] === 'object') {
            selectedIds = newCr.existingTitles.map((t: any) => +t.id);
          } else {
            selectedIds = newCr.existingTitles.map((id: any) => +id);
          }
        }

        newCr.existingTitles = selectedIds;

        // Convert to comma-separated ranks (for backend)
        const foundTitles = this.data.titlesForCriteria.filter((t: any) =>
          selectedIds.includes(t.id)
        );
        newCr.criteria = foundTitles.map((t: any) => t.rank).join(',');
        //setting default value as 0 for title criteria
        newCr.value = 0;
      } 
      else if (newCr.criteriaType === 'Flags') {
        const vd = this.data.flagsForCriteria.find((c: any) => c.code === newCr.criteria);;
        if (vd) {
          const flagValue = vd.flagValues.find((ele: any) => ele.value === newCr.value);
          if (flagValue) {
            newCr.value = flagValue.id;
            cr.flagDescription = flagValue.description;
          }
        }
      } else if (newCr.criteriaType === 'Duration') {
        const periodDef = this.data.consecutivePeriodsArray.find((c: any) => c.name === newCr.criteria);
        newCr.criteria = periodDef ? periodDef.code : newCr.criteria;
      }
      return newCr;
    });

    const expressionRuleSet = { expressionRules: payload };

    // Validate with backend first
    this.rateCardService.validateExpression(expressionRuleSet).then(
      (result) => {
        const value = JSON.parse(JSON.stringify(result));
        if (value && value.data) {
          // Build UI model (with proper display names)
          const uiCriteriaRates = this.criteriaRates.map((cr: any, idx: number) => {
            const processed = { ...cr };
            const payloadCr = payload[idx];

            processed.criteria = payloadCr.criteria;
            processed.existingTitles = payloadCr.existingTitles;

            // Set readable display name for Titles
            if (processed.criteriaType === 'Titles' && Array.isArray(processed.existingTitles)) {
              const foundTitles = this.data.titlesForCriteria
                .filter((t: any) => processed.existingTitles.includes(+t.id))
                .map((t: any) => t.name);
              processed.criteriaDisplay = foundTitles.join(', ');
            } else {
              processed.criteriaDisplay = processed.criteria;
            }

            return processed;
          });


          this.closeModal.emit({ action: 'apply', cr: this.criteriaRates });
          this.dialog.hide();
          this.toastr.success(COMMON_UMS.operationSuccess, COMMON_UMS.SUCCESS);
        }
      },
      (reason) => this.commonService.commonErrorHandler(reason)
    );
  }

  public criteriaTypeChange(cr: any, val: any) {
    cr.criteriaArray = [];
    cr.criteria = '';
    cr.value = '';
    cr.operator = '';
    cr.existingTitles = []; // For Titles multi-select
    cr.isValueDisabled = false;
    const disp = this.criteriaTypesArray.find((rec) => {
      return rec.code == val
    });
    cr.criteriaTypeDisplay = disp ? disp.name : '';
    if (val === 'Volumes') {
      cr.criteriaArray = this.data.globalVolDefinitions;
      cr.operatorsArray = this.data.operators;
    } else if (val === 'Key Metrics') {
      cr.criteriaArray = this.data.metricDefinitionsMetaData;
      cr.operatorsArray = this.data.operators;
    } else if (val === 'Titles') {
      cr.criteriaArray = this.data.titlesForCriteria;
      cr.operatorsArray = ['IN', 'NOT IN'];
      cr.value = null; // Value input disabled
    } else if (val === 'Flags') {
      cr.criteriaArray = this.data.flagsForCriteria;
      cr.operatorsArray = ['==','!='];
    } else if (val === 'Duration') {
      cr.criteriaArray = this.data.consecutivePeriodsArray;
      cr.operatorsArray = this.data.operators;
    } else {
      cr.criteriaArray = [];
      cr.operatorsArray = this.data.operators;
    }
  }

  public addNewCR() {
    this.noCriteriaRules = false;
    const criteriaRate: any = new Criteria();
    criteriaRate['operation'] = 'Create';
    criteriaRate['operationIndex'] = this.crOperationIndex;
    criteriaRate['isValueDisabled'] = false;
    this.crOperationIndex++;
    this.criteriaRates.push(criteriaRate);
  }

  public removeCR(cr: any, index: number) {
    if (cr.id) {
      cr['operation'] = 'Delete';
      this.crForm.form.markAsDirty();
      this.criteriaRates.splice(index, 1);
    } else {
      this.criteriaRates.splice(index, 1);
    }

    // logic to show No Volume Rules
    const deletedCriteriaRules = this.criteriaRates.filter(function (rule) {
      return (rule.operation === 'Delete');
    });
    this.noCriteriaRules = (deletedCriteriaRules.length === this.criteriaRates.length);
  }

  public onOperatorChange(cr: any) {
    // If + or - is selected, disable the value input
    if (cr.operator === '+' || cr.operator === '-') {
      cr.value = null; // Clear any existing value
      cr.isValueDisabled = true;
    } else if (cr.criteriaType === 'Titles' && (cr.operator === 'IN' || cr.operator === 'NOT IN')) {
      cr.value = null;
      cr.isValueDisabled = true;
    } else {
      cr.isValueDisabled = false;
    }

  }

    public getOperators(cr: any): string[] {
    if (!cr.criteriaType) {
      return [];
    }
 
    if (cr.criteriaType === 'Titles') {
      return ['IN', 'NOT IN'];
    }
 
    if (cr.criteriaType === 'Flags') {
      return cr.criteria ? ['==','!='] : [];
    }
 
    if (cr.criteriaType === 'Volumes' || cr.criteriaType === 'Key Metrics') {
      return [...(cr.operatorsArray || []), '+', '-'];
    }
 
    return cr.operatorsArray || [];
  }
 
 public isAllFieldsFilledExceptSpecialOperator(): boolean {
    return this.criteriaRates.every((cr) => {
      if (cr.operation === 'Delete') return true;
 
      // At least one field must be filled in the row
      const hasAnyValue =
        cr.startOperator ||
        cr.criteriaType ||
        cr.criteria ||
        cr.operator ||
        (cr.existingTitles && cr.existingTitles.length > 0) ||
        (cr.value !== undefined && cr.value !== null && cr.value !== '') ||
        cr.endOperator;
 
      if (!hasAnyValue) return false; // Row is completely empty
 
      // If criteriaType is not selected, row is valid as long as some field is filled
      if (!cr.criteriaType) return true;
 
      // Operator is always required if criteriaType is selected
      if (!cr.operator) return false;
 
      // ----- CASE 1: Titles -----
      if (cr.criteriaType === 'Titles') {
        return cr.existingTitles && cr.existingTitles.length > 0;
      }
 
      // ----- CASE 2: Volumes / Key Metrics -----
      if (cr.criteriaType === 'Volumes' || cr.criteriaType === 'Key Metrics') {
        // If value field is disabled or operator is + / -, don't require value
        if (cr.isValueDisabled || cr.operator === '+' || cr.operator === '-') {
          return !!cr.criteria;
        }
        // Otherwise, require both criteria and value
        return cr.criteria && cr.value !== undefined && cr.value !== null && cr.value !== '';
      }
 
      // ----- CASE 3: All other types -----
      return cr.criteria && (cr.value !== undefined && cr.value !== null && cr.value !== '');
    });
  }

  public preventInvalidInput(event: KeyboardEvent) {
    const invalidKeys = ['-', '+', 'e', 'E', '.'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  public sanitizeInput(cr: any) {
    // If decimal is entered via paste, remove it
    if (cr.value && (!Number.isInteger(+cr.value) || cr.value < 0)) {
      cr.value = Math.max(0, Math.floor(cr.value));
    }
  }

  public criteriaChange(cr: any, criteria: any) {
    if(cr.criteriaType === 'Flags'){
    const flag = cr.criteriaArray.find((item: any) => item.code === criteria);
    if (flag && flag.flagValues) {
      cr.flagValues = flag.flagValues.map((item: any) => {
        return {
          ...item,
          name:item.value
      };
      });
    } else {
      cr.flagValues = [];
    }
    }
  }
}
